import { useEffect, useState } from "react";
const entries = new Map();
const listeners = new Set();
const emit = () => listeners.forEach(listener => listener([...entries.values()]));
export function updatePendingVodUpload(id, patch) {
  if (!id) return;
  if (patch.queueId) {
    for (const [key, entry] of entries) if (key !== id && entry.queueId === patch.queueId) entries.delete(key);
  }
  entries.set(id, { ...entries.get(id), id, ...patch });
  emit();
}
export function removePendingVodUpload(id) { if (entries.delete(id)) emit(); }
export function usePendingVodUploads(teamId, mapId, savedVideos = []) {
  const [uploads, setUploads] = useState(() => [...entries.values()]);
  useEffect(() => { listeners.add(setUploads); setUploads([...entries.values()]); return () => { listeners.delete(setUploads); }; }, []);
  useEffect(() => {
    savedVideos.forEach(video => {
      const entry = entries.get(video.id);
      if (entry?.teamId === teamId && entry.mapId === (video.mapId || mapId)) removePendingVodUpload(video.id);
    });
  }, [savedVideos, teamId, mapId]);
  return uploads.filter(entry => entry.teamId === teamId && entry.mapId === mapId && !savedVideos.some(video => video.id === entry.id && (!video.mapId || video.mapId === mapId)));
}
